export const MenusFuncionarioEnum = {
  Dashboard: 1,
  Pedidos: 2,
  Chat: 3,
  Revendas: 4,
  Configuracoes: 5,
  Relatorios: 6,
  Financas: 7,
  Organizacoes: 8,
  QuadroDeAvisos: 9,
  Cupons: 10,
  Desempenho: 11,
  TelefonesBloqueados: 12,
  IndiqueGanhe: 13
}

const {
  Dashboard,
  Pedidos,
  Chat,
  Revendas,
  Configuracoes,
  Relatorios,
  Financas,
  Organizacoes,
  QuadroDeAvisos,
  Cupons,
  Desempenho,
  TelefonesBloqueados,
  IndiqueGanhe
} = MenusFuncionarioEnum

export const MenuFuncionarioEnum = [
  { value: Dashboard, text: "Dashboard" },
  { value: Pedidos, text: "Pedidos" },
  { value: Chat, text: "Chat" },
  { value: Revendas, text: "Revendas " },
  { value: Configuracoes, text: "Configurações" },
  { value: Relatorios, text: "Relatórios" },
  { value: Financas, text: "Finanças" },
  { value: Organizacoes, text: "Organizações" },
  { value: QuadroDeAvisos, text: "Quadros De Aviso" },
  { value: Cupons, text: "Cupons" },
  { value: Desempenho, text: "Desempenho" },
  { value: TelefonesBloqueados, text: 'Telefones Bloqueados'},
  { value: IndiqueGanhe, text: 'Indique e Ganhe'}
]
